<template>
  <div class="c-led-pcb" v-visible="!loading">
    <img
      class="background"
      :src="images.led_in_switch_65_less"
      @load="onLoad"
    />
    <div class="leds">
      <div
        v-for="LED in LEDs"
        class="led"
        :class="{
          disabled: isPlaying,
        }"
        :key="LED.index"
        :style="LED.style"
        @mousedown.left="
          onMouseDownLeft({ color: frameRGB[LED.index], index: LED.index })
        "
        @mousedown.right="
          onMouseDownRight({ color: frameRGB[LED.index], index: LED.index })
        "
        @mouseenter="
          onMouseEnter({ color: frameRGB[LED.index], index: LED.index }, $event)
        "
        @contextmenu.prevent
      >
        <div class="content">
          <div
            class="background"
            :style="{ backgroundColor: frameRGB[LED.index] }"
          ></div>
          <div
            class="center"
            :style="{
              backgroundColor: frameRGB[LED.index],
              boxShadow:
                (LED.boxShadow || '0 0 0.45rem 0.2rem ') + frameRGB[LED.index],
              opacity: 1 || getLight(frameRGB[LED.index]),
            }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { speedList } from "@/utils";

export default {
  name: "CLedPcb65LessSplit",
  props: {
    isPlaying: Boolean,
    speed: Number,
    frames: Array,
    frameIndex: Number,
  },
  data() {
    return {
      loading: true,
      playingIndex: 0,
      LEDs: [
        {
          index: 0,
          style: { top: "10.6%", left: "2.7%" },
        },
        {
          index: 1,
          style: { top: "10.6%", left: "9.2%" },
        },
        {
          index: 2,
          style: { top: "10.6%", left: "15.6%" },
        },
        {
          index: 3,
          style: { top: "10.6%", left: "22.0%" },
        },
        {
          index: 4,
          style: { top: "10.6%", left: "28.4%" },
        },
        {
          index: 5,
          style: { top: "10.6%", left: "34.8%" },
        },
        {
          index: 6,
          style: { top: "10.6%", left: "41.2%" },
        },
        {
          index: 7,
          style: { top: "10.6%", left: "47.6%" },
        },
        {
          index: 8,
          style: { top: "10.6%", left: "54.0%" },
        },
        {
          index: 9,
          style: { top: "10.6%", left: "60.4%" },
        },
        {
          index: 10,
          style: { top: "10.6%", left: "66.9%" },
        },
        {
          index: 11,
          style: { top: "10.6%", left: "73.3%" },
        },
        {
          index: 12,
          style: { top: "10.6%", left: "79.6%" },
        },
        {
          index: 41,
          style: { top: "10.6%", left: "86.2%" },
        },
        {
          index: 55,
          style: { top: "10.6%", left: "92.5%" },
        },
        {
          index: 14,
          style: { top: "26.1%", left: "4.4%" },
        },
        {
          index: 15,
          style: { top: "26.1%", left: "12.4%" },
        },
        {
          index: 16,
          style: { top: "26.1%", left: "18.8%" },
        },
        {
          index: 17,
          style: { top: "26.1%", left: "25.2%" },
        },
        {
          index: 18,
          style: { top: "26.1%", left: "31.6%" },
        },
        {
          index: 19,
          style: { top: "26.1%", left: "38.0%" },
        },
        {
          index: 20,
          style: { top: "26.1%", left: "44.4%" },
        },
        {
          index: 21,
          style: { top: "26.1%", left: "50.8%" },
        },
        {
          index: 22,
          style: { top: "26.1%", left: "57.2%" },
        },
        {
          index: 23,
          style: { top: "26.1%", left: "63.6%" },
        },
        {
          index: 24,
          style: { top: "26.1%", left: "70.0%" },
        },
        {
          index: 25,
          style: { top: "26.1%", left: "76.5%" },
        },
        {
          index: 26,
          style: { top: "26.1%", left: "82.9%" },
        },
        {
          index: 27,
          style: { top: "26.1%", left: "90.9%" },
        },
        {
          index: 28,
          style: { top: "41.6%", left: "5.1%" },
        },
        {
          index: 29,
          style: { top: "41.6%", left: "13.9%" },
        },
        {
          index: 30,
          style: { top: "41.6%", left: "20.3%" },
        },
        {
          index: 31,
          style: { top: "41.6%", left: "26.8%" },
        },
        {
          index: 32,
          style: { top: "41.6%", left: "33.2%" },
        },
        {
          index: 33,
          style: { top: "41.6%", left: "39.6%" },
        },
        {
          index: 34,
          style: { top: "41.6%", left: "46.0%" },
        },
        {
          index: 35,
          style: { top: "41.6%", left: "52.4%" },
        },
        {
          index: 36,
          style: { top: "41.6%", left: "58.8%" },
        },
        {
          index: 37,
          style: { top: "41.6%", left: "65.2%" },
        },
        {
          index: 38,
          style: { top: "41.6%", left: "71.6%" },
        },
        {
          index: 39,
          style: { top: "41.6%", left: "78.0%" },
        },
        {
          index: 40,
          style: { top: "41.6%", left: "88.5%" },
        },
        {
          index: 42,
          style: { top: "57.3%", left: "6.7%" },
        },
        {
          index: 43,
          style: { top: "57.3%", left: "17.1%" },
        },
        {
          index: 44,
          style: { top: "57.3%", left: "23.5%" },
        },
        {
          index: 45,
          style: { top: "57.3%", left: "29.9%" },
        },
        {
          index: 46,
          style: { top: "57.3%", left: "36.3%" },
        },
        {
          index: 47,
          style: { top: "57.3%", left: "42.8%" },
        },
        {
          index: 48,
          style: { top: "57.3%", left: "49.2%" },
        },
        {
          index: 49,
          style: { top: "57.3%", left: "55.6%" },
        },
        {
          index: 50,
          style: { top: "57.3%", left: "62.0%" },
        },
        {
          index: 51,
          style: { top: "57.3%", left: "68.4%" },
        },
        {
          index: 52,
          style: { top: "57.3%", left: "74.8%" },
        },
        {
          index: 53,
          style: { top: "57.3%", left: "83.6%" },
        },
        {
          index: 54,
          style: { top: "57.3%", left: "92.5%" },
        },
        {
          index: 56,
          style: { top: "73.0%", left: "12.3%" },
        },
        {
          index: 57,
          style: { top: "73.0%", left: "20.3%" },
        },
        {
          index: 61,
          style: { top: "73.0%", left: "28.4%" },
        },
        {
          index: 62,
          style: { top: "73.0%", left: "47.6%" },
        },
        {
          index: 63,
          style: { top: "73.0%", left: "66.7%" },
        },
        {
          index: 68,
          style: { top: "73.0%", left: "74.8%" },
        },
        {
          index: 69,
          style: { top: "73.0%", left: "82.8%" },
        },
        {
          index: 77,
          style: { top: "93.0%", left: "1%", width: "2%" },
          boxShadow: "0 0 0.2rem 0.05rem ",
        },
        {
          index: 76,
          style: { top: "93.0%", left: "3%", width: "2%" },
          boxShadow: "0 0 0.2rem 0.05rem ",
        },
        {
          index: 75,
          style: { top: "93.0%", left: "5%", width: "2%" },
          boxShadow: "0 0 0.2rem 0.05rem ",
        },
        {
          index: 74,
          style: { top: "93.0%", left: "7%", width: "2%" },
          boxShadow: "0 0 0.2rem 0.05rem ",
        },
        {
          index: 73,
          style: { top: "93.0%", left: "91%", width: "2%" },
          boxShadow: "0 0 0.2rem 0.05rem ",
        },
        {
          index: 72,
          style: { top: "93.0%", left: "93%", width: "2%" },
          boxShadow: "0 0 0.2rem 0.05rem ",
        },
        {
          index: 71,
          style: { top: "93.0%", left: "95%", width: "2%" },
          boxShadow: "0 0 0.2rem 0.05rem ",
        },
        {
          index: 70,
          style: { top: "93.0%", left: "97%", width: "2%" },
          boxShadow: "0 0 0.2rem 0.05rem ",
        },
      ],
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    frameRGB() {
      if (this.frames) {
        const index = this.isPlaying ? this.playingIndex : this.frameIndex;
        return this.frames[index] ? this.frames[index].frame_RGB : [];
      }
      return [];
    },
  },
  watch: {
    isPlaying: function (isPlaying) {
      if (isPlaying) {
        this.play();
      }
    },
    speed() {
      this.play();
    },
  },
  methods: {
    getLight(hex) {
      const regs = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

      let r = parseInt(regs[1], 16);
      let g = parseInt(regs[2], 16);
      let b = parseInt(regs[3], 16);

      (r /= 255), (g /= 255), (b /= 255);

      const max = Math.max(r, g, b);
      const light = max * 2;
      return light.toFixed(3);
    },
    play() {
      this.playingIndex = 0;
      clearTimeout(this.timer);
      if (this.isPlaying) {
        const speed = speedList[this.speed - 1] - 2;
        this.timer = setInterval(() => {
          this.playingIndex = this.playingIndex + 1;
          if (this.playingIndex >= this.frames.length) this.playingIndex = 0;
        }, speed);
      }
    },
    onLoad() {
      this.loading = false;
    },
    onMouseDownLeft({ color, index }) {
      this.$emit("led-click", { color, index });
    },
    onMouseDownRight({ index }) {
      this.$emit("led-click-right", { index });
    },
    onMouseEnter({ color, index }, { which, buttons }) {
      if (buttons === undefined ? which === 1 : buttons === 1) {
        this.$emit("led-click", { color, index });
      } else if (buttons === undefined ? which === 3 : buttons === 2) {
        this.$emit("led-click-right", { index, solid: true });
      }
    },
  },
  mounted() {
    if (this.isPlaying) this.play();
  },
};
</script>

<style lang="scss" scoped>
.c-led-pcb {
  width: 100%;
  position: relative;

  .background {
    width: 100%;
    height: auto;
    position: relative;
    -webkit-user-drag: none;
  }

  .leds {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0%;
    top: 0%;

    .led {
      width: 4.8%;
      height: 12%;
      padding: 0 0.2%;
      position: absolute;
      cursor: pointer;

      &:hover .content .background {
        // display: block;
      }

      &.disabled {
        background: transparent;
        pointer-events: none;
        cursor: auto;
      }

      .content {
        width: 100%;
        height: 100%;
        position: relative;

        .background {
          width: 100%;
          height: 100%;
          position: absolute;
          display: none;
        }

        .center {
          width: 12px;
          height: 12px;
          left: 50%;
          top: 50%;
          margin-top: -6px;
          margin-left: -6px;
          border-radius: 12px;
          position: absolute;
          filter: brightness(120%);
        }
      }
    }
  }
}
</style>
